export default defineNuxtPlugin(() =>
{
    const onKeydown = (event: KeyboardEvent) =>
    {
        if (event.key === 'Tab' && !event.altKey && !event.ctrlKey && !event.metaKey)
            document.documentElement.dataset.keyboardFocus = 'true';
    };
    const onPointerDown = () => delete document.documentElement.dataset.keyboardFocus;

    document.addEventListener('keydown', onKeydown, true);
    document.addEventListener('pointerdown', onPointerDown, true);

    if (import.meta.hot)
    {
        import.meta.hot.dispose(() =>
        {
            document.removeEventListener('keydown', onKeydown, true);
            document.removeEventListener('pointerdown', onPointerDown, true);
            delete document.documentElement.dataset.keyboardFocus;
        });
    }
});
